import { renderScene } from "../glass-w/glass-w"

const root = document.getElementById("glass-hero")

if (root) {
  renderScene(root)
}
